import React from 'react';
import Money from "../../../lib/Money";
import CartDisplayTotal from "./CartDisplayTotal";
import CartDisplayShippingTotal from "./CartDisplayShippingTotal";
import {isEmpty} from "lodash";
import TaxExemptIndicator from "./TaxExemptIndicator";
import PayLaterIndicator from "../../../ShoppingCart/components/sidebar/PayLaterIndicator";
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";
import CustomerPoNumberIndicator from "../../../ShoppingCart/components/sidebar/CustomerPoNumberIndicator";

// 2023-01 modernized
export default function CartSummaryTable({shoppingCart={}}) {
  const { shippingAddress={}, totals={} } = shoppingCart;

  const {regularSubtotal, subtotalSavings,
    effectiveShipping, effectiveTax, effectiveTotal } = totals;

  // look for shippingAddress id, indicating its is persisted
  const showTax = !!(shippingAddress?.id || effectiveTax);

  return <ul id="cart-summary-table">
    <CartDisplayTotal
      id="regular-subtotal"
      label="Subtotal"
      value={regularSubtotal}
    />

    <CartDisplayTotal
      id="savings"
      label="Savings"
      optional="true"
      value={- (subtotalSavings || 0)}
    />

    <CartDisplayShippingTotal
      id="shipping"
      label="Shipping"
      value={effectiveShipping}
      shippingAddress={shippingAddress}
    />

    {
      showTax && <CartDisplayTotal
        id="tax"
        label="Tax"
        value={effectiveTax}
      />}

    <CartDisplayTotal
      id="total"
      label="Total"
      value={effectiveTotal}
    />

    <TaxExemptIndicator shoppingCart={shoppingCart} />
    <PayLaterIndicator shoppingCart={shoppingCart} />
    <CustomerPoNumberIndicator shoppingCart={shoppingCart} />

  </ul>
}


